export default "__VITE_ASSET__Bf3U1NJe__"